import { render } from "./index.vue?vue&type=template&id=137dbc5e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/organisms/transition-type-service/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "137dbc5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('137dbc5e', __exports__)) {
    api.reload('137dbc5e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=137dbc5e", () => {
    api.rerender('137dbc5e', render)
  })

}


export default __exports__